import { render, staticRenderFns } from "./haokaShopAgr.vue?vue&type=template&id=2bba32b2&scoped=true&"
import script from "./haokaShopAgr.vue?vue&type=script&lang=js&"
export * from "./haokaShopAgr.vue?vue&type=script&lang=js&"
import style0 from "./haokaShopAgr.vue?vue&type=style&index=0&id=2bba32b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba32b2",
  null
  
)

export default component.exports